import {useQuery} from "react-query";
import request from "../../../shared/request";


export const useGetSubscriptions = () => {

    return useQuery(['subscriptions'], () => request({
        url: `/api/subscriptions`
    }))
}